"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotModalRoleListInjectionKey = void 0;
exports.SlotModalRoleListInjectionKey = Symbol('slotModalRoleList');
